// https://confluence.ahtp.fi/pages/viewpage.action?pageId=43483766

// Must match Magnolia errorReporter implementation
export const EVENT_ID = 'tmtErrorOccurred';

// Must match backend implementation
export const SPECIAL_HEADER = 'tmt-e-cs';
export const SENDER = 'sender';
export const DISPLAY_TEXT = 'displayText';
export const DATA = 'data';
export const ERRORCODE = 'errorCode';

export const INTERNAL_VALIDATION_KEY = '_tmtVpInternalError';
export const ERRORCODE_GENERAL = 'TMT_ERROR_GENERAL';
export const ERRORCODE_UNAUTHORIZED = 'TMT_ERROR_UNAUTHORIZED';
export const ERRORCODE_DEFAULT = ERRORCODE_GENERAL;
